export const TAB_KEYS = {
  AUTO_TOPIC_DISCOVERY: "auto-topic-discovery",
  IMPACT_ANALYSIS: "impact-analysis",
} as const;

export type TabValue = (typeof TAB_KEYS)[keyof typeof TAB_KEYS];
